export default __webpack_public_path__ + "static/media/trustwallet-icon.ef11e213.png";